import { useEffect, useState, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./styles.scss";
import { gameTips } from "../../../mock/game-tips";
import { Icon } from "@/components";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { useAuth } from "@/contexts/auth-context";
import { useCachedActivities } from "@/hooks/useCachedActivities";
import { activitiesFetch } from "@/redux/slice/activity/activities";
import { activitiesMock } from "@/mock/activties";
import { useLanguageContext } from "@/contexts/language-context";

export const GameLoading = () => {
  const [tip, setTip] = useState(gameTips[0]);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { level_id, lesson_id } = useParams();
  const { gameTimeStamp, updateGameTimeStamp, updateTrialCount, token } =
    useAuth();
  const { data, loading } = useAppSelector((state) => state.activities);

  const activities = data && !loading ? data?.length : 0;
  const mainData = data && data;
  const [isCachingComplete, setIsCachingComplete] = useState(false);
  const cachedActivities = useCachedActivities(mainData);
  const { values } = useLanguageContext();

  useEffect(() => {
    const interval = setInterval(() => {
      setTip(gameTips[Math.floor(Math.random() * gameTips?.length)]);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const fetchData = useCallback(() => {
    if (token) {
      dispatch(
        activitiesFetch({
          token,
          level_id,
          lesson_id,
          language: values.selectedLanguage,
        })
      );
    }
  }, [dispatch, token, level_id, lesson_id, values.selectedLanguage]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  useEffect(() => {
    if (!loading && activities > 0 && cachedActivities?.length > 0) {
      setIsCachingComplete(true);
    }
  }, [cachedActivities, loading, activities]);

  useEffect(() => {
    if (isCachingComplete) {
      navigate(
        `/activity/level/${level_id}/lesson/${lesson_id}/brief/trivia-activity`,
        { state: { cachedActivities } }
      );
      updateTrialCount(0);
      updateGameTimeStamp({ ...gameTimeStamp, start: Date.now() });
    }
  }, [
    isCachingComplete,
    navigate,
    cachedActivities,
    updateTrialCount,
    updateGameTimeStamp,
    gameTimeStamp,
    level_id,
    lesson_id,
  ]);

  return (
    <div className="game-loading-container">
      <div className="content-container">
        <Icon name="logo" width={70} height={70} />
        <h1 className="title">{tip.title}</h1>
        <p className="desc">{tip.desc}</p>
        <div className="loading-container">
          <p className="loading-text">Loading . . .</p>
        </div>
      </div>
    </div>
  );
};
